/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S3_P1Inputs */

const en_guide_json_syntax_errors_s3_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard JSON does not support any form of comments. If you paste JSON that contains <code>//</code> or <code>/* */</code> comments, the parser will fail. Remove all comments before parsing, or use a JSONC-aware parser.`)
};

const ko_guide_json_syntax_errors_s3_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표준 JSON은 어떤 형태의 주석도 지원하지 않습니다. <code>//</code>이나 <code>/* */</code> 주석이 포함된 JSON을 붙여넣으면 파서가 실패합니다. 파싱 전에 모든 주석을 제거하거나 JSONC 인식 파서를 사용하세요.`)
};

const ja_guide_json_syntax_errors_s3_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準のJSONはいかなる形式のコメントもサポートしていません。<code>//</code>や<code>/* */</code>のコメントを含むJSONを貼り付けると、パーサーがエラーになります。パース前にすべてのコメントを削除するか、JSONC対応のパーサーを使用してください。`)
};

/**
* | output |
* | --- |
* | "Standard JSON does not support any form of comments. If you paste JSON that contains <code>//</code> or <code>/* *\/</code> comments, the parser will fail. Re..." |
*
* @param {Guide_Json_Syntax_Errors_S3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s3_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s3_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s3_p1(inputs)
	return ja_guide_json_syntax_errors_s3_p1(inputs)
});